import { render, staticRenderFns } from "./cadre-education.vue?vue&type=template&id=23e7e16c&scoped=true"
var script = {}
import style0 from "./cadre-education.vue?vue&type=style&index=0&id=23e7e16c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7e16c",
  null
  
)

export default component.exports